import * as React from 'react';
import CameraUploader from './CameraDocs';
import { Button, Badge } from 'reactstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from "moment"
import { downloadFile, deleteFile, showfile } from "../api/files"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function FileList({ initBots }) {

    const [bots, setBots] = React.useState(initBots || []);

    return (

        <DataTable
            value={bots}
            responsive
            autoLayout={false}
            className="p-datatable-hoverable-rows p-datatable-customers"
            emptyMessage={() => (<div className="text-center">Nessuno storico in tabella</div>)}
        >
            <Column
                field="id"
                header="Test"
                style={{ wordWrap: 'break-word' }}
            />
            <Column
                field="value.timestamp"
                header="Data/Ora"
                style={{ wordWrap: 'break-word' }}
                body={(rowData, column) => {
                    if (rowData.value !== undefined) {
                        return (moment(rowData.value.timestamp).format("DD/MM/YYYY HH:mm"))
                    }
                }}
            />
            <Column
                field="value.question"
                header="Domanda"
                style={{ wordWrap: 'break-word' }}
            />
            <Column
                field="value.answer"
                header="Risposta"
                style={{ wordWrap: 'break-word' }}
                body={(rowData, column) => {
                    if (rowData.value !== undefined) {
                        return (rowData.value.answer ? <Badge className="m-1" color="primary">Si</Badge> : "")
                    }
                }}
            />
            <Column
                field="value.completed"
                header="Completato"
                style={{ wordWrap: 'break-word' }}
                body={(rowData, column) => {
                    if (rowData.value !== undefined) {
                        return (rowData.value.completed ? <Badge className="m-1" color="success">Si</Badge> : "")
                    }
                }}
            />
            <Column
                field="value.skipped"
                header="Forzato"
                style={{ wordWrap: 'break-word' }}
                body={(rowData, column) => {
                    if (rowData.value !== undefined) {
                        return (rowData.value.skipped ? <Badge className="m-1" color="danger">Si</Badge> : "")
                    }
                }}
            />
            <Column
                field="value.error"
                header="Errori"
                style={{ wordWrap: 'break-word' }}
            />

        </DataTable>

    );
}
